define('services/i18n',[
    'underscore', 'backbone', 'moment', 'utils', 'debug',
    'i18next',
    'i18nextXHRBackend',
    'i18nextLocizeBackend',
    'i18nextLocalStorageCache'
], function(
    _, Backbone, moment, U, DEBUG,
    i18next,
    XHRBackend,
    LocizeBackend,
    Cache
) {

    /**
     * While developing on a local machine, add the locize api key to your
     * localStorage and it will enable the locize backend.
     */
    var locizeApiKey = localStorage.getItem('locize-api-key'),
        useLocize = DEBUG && locizeApiKey,
        Backend = useLocize ? LocizeBackend : XHRBackend,
        backendOptions = useLocize ? {
            /**
             * Development locize backend options
             */
            projectId: 'e1712866-dfc7-4677-8cf6-b133d3a04cd7',
            apiKey: locizeApiKey,
            referenceLng: 'en-CA'
        } : {
            /**
             * Production XHR backend options
             */
            loadPath: "assets/i18n/{{lng}}/{{ns}}.json"
        },
        initOptions = {
            // debug: DEBUG,
            ns: [
                "activities",
                "api-messages",
                "calendar",
                "conversation",
                "countries",
                "general",
                "goal",
                "graph",
                "languages",
                "menu",
                "messages",
                "note",
                "questionnaire",
                "payment",
                "provinces",
                "settings",
                "supervisor",
                "template",
                "timezones",
                "tutorials"
            ],
            defaultNS: "general",
            fallbackLng: {
                'en-CA': ['en'],
                'en-US': ['en'],
                'fr-FR': ['fr', 'en'],
                'fr-CA': ['fr', 'en'],
                'de': ['en'],
                'es': ['en'],
                'nl': ['en'],
                'pt': ['en'],
                'ko': ['en'],
                'default': ['en']
            },
            load: "languageOnly",
            whitelist: ["fr", "fr-CA", "fr-FR", "en", "en-CA", "en-US", "de", "es", "ko", "nl", "pt"],
            nsSeparator: ":",
            keySeparator: false,
            highlightTranslated: false,

            // Will try to send missing keys to the backend service
            saveMissing: useLocize,

            backend: backendOptions,
            cache: {
                // enabled: debug,
                prefix: 'i18next_res_', // prefix for stored languages
                expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days
            }
        };

    // When ready to find missing keys.
    // if (DEBUG && !useLocize) {
    //     initOptions.missingKeyHandler = function(lng, ns, key, fallbackValue) {
    //         U.log("Missing:", lng, ns, "\'" + key + "\'");
    //     };
    // }

    /**
     * Initialize i18next
     */
    var i18n = i18next
        .use(Backend)
        .use(Cache)
        .init(initOptions, function(err, t) {
            if (err) U.warn("translation error:", err);

            // TODO (maybe) find a way to trigger translation of the app, re-rendering or something.
        });

    ////////////
    // Extend //
    ////////////
    /**
     * Implement the jQuery promise interface into existing i18next function.
     * @param  {String|Array} lngs lang code or array of lang codes.
     * @param  {Function} callback done
     * @param  {Object}   context
     * @return {Promise}
     */
    i18n.loadLanguages = (function(loadLanguages) {
        return function(lngs, callback, context) {
            var deferred = Backbone.$.Deferred();
            loadLanguages.call(i18n, lngs, function() {
                _.callback(context, callback);
                deferred.resolveWith(context);
            });
            return deferred;
        };
    })(i18n.loadLanguages);

    i18n.loadLanguages(['fr', 'en', 'de', 'es', 'ko', 'nl', 'pt']);

    /**
     * Implement the jQuery promise interface into existing i18next function.
     * @param  {String|Array} ns namespace name or array of namespace names.
     * @param  {Function} callback done
     * @param  {Object}   context
     * @return {Promise}
     */
    i18n.loadNamespaces = (function(loadNamespaces) {
        return function(ns, callback, context) {
            var deferred = Backbone.$.Deferred();
            loadNamespaces.call(i18n, ns, function() {
                _.callback(context, callback);
                deferred.resolveWith(context);
            });
            return deferred;
        };
    })(i18n.loadNamespaces);


    i18n.setLanguage = function(language, force = false) {
        document.cookie = "i18n=" + language;
        window.localStorage.setItem('i18nLng', language);

        if (force) {
            this.changeLanguage(language)
            moment.locale(language)
        }
    };

    /**
     * Override the default backbone sync to set the language request header.
     */
    Backbone.sync = (function(sync) {
        return function(method, model, options) {
            options = options || {};
            var beforeSend = options.beforeSend;
            options.beforeSend = function(xhr) {
                xhr.setRequestHeader('Accept-Language', i18n.language);
                if (beforeSend) return beforeSend.apply(this, arguments);
            };
            return sync.apply(this, arguments);
        };
    })(Backbone.sync);

    return i18n;
});

